import { gql } from "@apollo/client";

export default gql`
  mutation InsertLogs($audit: AuditInputs!) {
    insertLogs(audit: $audit)
  }
`;
